(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function toPx(value) {
      value = (value || '').trim();
      var rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      if (value.slice(-3) === 'rem') return parseFloat(value) * rootFont;
      if (value.slice(-2) === 'px') return parseFloat(value);
      var n = parseFloat(value);
      return isNaN(n) ? 0 : n * rootFont;
    }

    function initShowMore(root) {
      var content = root.querySelector('[data-cd-content]');
      var toggle = root.querySelector('[data-cd-toggle]');
      if (!content || !toggle || root.dataset.cdReady === 'true') return;
      root.dataset.cdReady = 'true';

      function collapsedPx() {
        return toPx(getComputedStyle(root).getPropertyValue('--cd-max-height')) || 128;
      }

      function naturalHeight() {
        var prev = content.style.maxHeight;
        content.style.maxHeight = 'none';
        var h = content.scrollHeight;
        content.style.maxHeight = prev;
        return h;
      }

      function evaluate() {
        var limit = collapsedPx();
        var needsToggle = naturalHeight() > limit + 1;

        if (needsToggle) {
          toggle.hidden = false;
          content.classList.add('is-truncated');
          content.style.maxHeight = root.classList.contains('is-expanded') ? 'none' : limit + 'px';
        } else {
          toggle.hidden = true;
          content.classList.remove('is-truncated');
          root.classList.remove('is-expanded');
          content.style.maxHeight = 'none';
        }
      }

      function expand() {
        root.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      function collapse() {
        root.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = content.scrollHeight + 'px';
        void content.offsetHeight;
        content.style.maxHeight = collapsedPx() + 'px';

        if (root.getBoundingClientRect().top < 0) {
          root.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
        }
      }

      content.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'max-height') return;
        if (root.classList.contains('is-expanded')) {
          content.style.maxHeight = 'none';
        }
      });

      toggle.addEventListener('click', function () {
        if (root.classList.contains('is-expanded')) {
          collapse();
        } else {
          expand();
          setTimeout(function () {
            if (root.classList.contains('is-expanded')) {
              content.style.maxHeight = 'none';
            }
          }, 400);
        }
      });

      evaluate();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(evaluate);
      }

      if ('ResizeObserver' in window) {
        var lastWidth = root.getBoundingClientRect().width;
        var ro = new ResizeObserver(function (entries) {
          var w = entries[0].contentRect.width;
          if (Math.abs(w - lastWidth) > 0.5) {
            lastWidth = w;
            evaluate();
          }
        });
        ro.observe(root);
      } else {
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(evaluate, 150);
        });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-collection-showmore]').forEach(initShowMore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
